'use client';

import config from 'config';

import { Box, Flex, Heading, Link, useTheme, VStack } from '@chakra-ui/react';

import { NotFoundButtons } from 'types';

import { StaticMediaImage, Text } from 'ui';

const {
  notFound: { title, description, navigationLabel, bavigationButtons, image }
} = config;

const NotFound = () => {
  const {
    colors: {
      palette: { notFound: styles }
    }
  } = useTheme();

  return (
    <VStack
      h='full'
      flex={1}
      justifyContent='flex-start'
      gap='24px'
      px={{ base: '15px', md: 0 }}
      py={{ base: '50px', lg: '100px' }}
    >
      <VStack
        w={{ base: '90%', md: '80%' }}
        justifyContent='center'
        display={{ base: 'block', lg: 'none' }}
        mb={{ base: 0, md: '20px' }}
      >
        <Box w='full'>
          <StaticMediaImage
            priority
            alt='not-found'
            src={image}
            quality={100}
            style={{
              width: '100%',
              objectFit: 'cover'
            }}
          />
        </Box>
      </VStack>

      <Heading
        w={{ base: 'full', md: '80%', lg: '80%' }}
        fontSize={{ base: '24px', sm: '36px', md: '46px' }}
        fontWeight={{ base: 400, sm: 700 }}
        color={styles.title}
        textAlign={{ base: 'center', lg: 'left' }}
      >
        {title}
      </Heading>
      <Text
        w={{ base: 'full', md: '80%', lg: '80%' }}
        fontSize={{ base: '18px', sm: '24px', md: '34px' }}
        textAlign={{ base: 'center', lg: 'left' }}
        color={styles.description}
        px={{ base: '16px', md: 0 }}
        lineHeight={{ base: '26px', md: 'initial' }}
      >
        {description}
      </Text>
      <Flex w='full'>
        <VStack
          w={{ base: 'full', lg: '44%' }}
          justifyContent='flex-start'
          alignItems='flex-start'
          gap={2}
          pl={{ base: 0, lg: '10%' }}
          pt='5%'
        >
          <Text
            w='full'
            textAlign={{ base: 'center', lg: 'left' }}
            fontSize={{ base: '22px', sm: '28px', md: '38px' }}
            mb={4}
          >
            {navigationLabel}
          </Text>
          {bavigationButtons.map(({ link, label }: NotFoundButtons) => (
            <Link
              w='full'
              textAlign={{ base: 'center', lg: 'left' }}
              pl={{ base: 0, md: 4 }}
              key={label}
              fontSize={{ base: '18px', sm: '20px', md: '24px' }}
              h={{ base: 'auto', md: '45px' }}
              style={{
                color: styles.buttonLabel,
                borderRadius: '25px',
                justifyContent: 'center',
                textTransform: 'uppercase',
                fontWeight: 'normal'
              }}
              variant='solid'
              href={link}
              _hover={{
                opacity: 0.4
              }}
            >
              {label}
            </Link>
          ))}
        </VStack>
        <VStack
          w={{ base: 'full', lg: '56%' }}
          justifyContent='center'
          display={{ base: 'none', lg: 'block' }}
        >
          <Box w='full'>
            <StaticMediaImage
              priority
              alt='not-found'
              src={image}
              quality={100}
              style={{
                width: '100%',
                objectFit: 'cover'
              }}
            />
          </Box>
        </VStack>
      </Flex>
    </VStack>
  );
};

export default NotFound;
